(() => {
	const selector = "[data-snugplay-price]";

	function formatMoney(amount) {
		const format = window.themeCore?.objects?.shop?.money_format || "${{amount}}";
		return window.themeCore?.utils?.formatMoney
			? window.themeCore.utils.formatMoney(amount, format)
			: (amount / 100).toLocaleString(undefined, { style: "currency", currency: window.Shopify?.currency?.active || "USD" });
	}

	function updatePrice(container, variant) {
		if (!variant) return;
		const price = Number(variant.price || 0);
		const comparePrice = Number(variant.compare_at_price || 0);
		const onSale = comparePrice > price;
		container.classList.toggle("is-on-sale", onSale);
		const currentPrice = container.querySelector("[data-snugplay-current-price]");
		const compareAtPrice = container.querySelector("[data-snugplay-compare-price]");
		const discount = container.querySelector("[data-snugplay-discount]");
		if (currentPrice) currentPrice.textContent = formatMoney(price);
		if (compareAtPrice) compareAtPrice.textContent = onSale ? formatMoney(comparePrice) : "";
		if (discount) {
			discount.textContent = onSale
				? `SAVE ${Math.ceil(((comparePrice - price) / comparePrice) * 100)}%`
				: "";
		}
		updateAddToBagLabel(container, variant, price);
	}

	function updateAddToBagLabel(container, variant, price) {
		const section = container.closest("[data-section-id]");
		if (!section) return;
		section.querySelectorAll(".product-add-to-cart .js-product-add-to-cart-button-text[data-snugplay-label]").forEach((label) => {
			const button = label.closest("button");
			if (!variant.available) {
				label.dataset.snugplayLabel = window.themeCore?.translations?.get("products.product.sold_out") || "Sold out";
			} else if (button?.hasAttribute("data-preorder")) {
				label.dataset.snugplayLabel = window.themeCore?.translations?.get("products.product.pre_order") || "Pre-order";
			} else {
				label.dataset.snugplayLabel = `Add to bag · ${formatMoney(price)}`;
			}
		});
	}

	function init(container) {
		if (container.dataset.snugplayPriceReady === "true") return;
		const section = container.closest("[data-section-id]");
		if (!section || !window.themeCore?.EventBus) return;
		container.dataset.snugplayPriceReady = "true";

		const applyVariant = (event = {}) => {
			updatePrice(container, event.variant || event.currentVariant);
		};

		window.themeCore.EventBus.listen(`pdp:section-${section.dataset.sectionId}:change-variant`, applyVariant);
		section.querySelectorAll("[data-js-product-form][id]").forEach((form) => {
			window.themeCore.EventBus.listen(`form:${form.id}:change-variant`, applyVariant);
		});

		const options = section.querySelector(".js-product-options");
		if (options) {
			const syncFromSelectedVariant = () => {
				const selectedVariant = section.querySelector("[data-selected-variant]");
				if (!selectedVariant?.textContent) return;
				try {
					updatePrice(container, JSON.parse(selectedVariant.textContent));
				} catch (error) {
					// The theme may briefly replace this JSON while fetching a new option selection.
				}
			};
			const observer = new MutationObserver(syncFromSelectedVariant);
			observer.observe(options, { childList: true, subtree: true, characterData: true });
		}
	}

	function initAll() {
		document.querySelectorAll(selector).forEach(init);
	}

	function initWhenReady(attempt = 0) {
		if (window.themeCore?.EventBus) {
			initAll();
			window.themeCore.EventBus.listen("product:loaded", initAll);
			return;
		}
		if (attempt < 100) window.setTimeout(() => initWhenReady(attempt + 1), 100);
	}

	document.addEventListener("DOMContentLoaded", initAll);
	document.addEventListener("shopify:section:load", initAll);
	document.addEventListener("theme:all:loaded", () => initWhenReady(), { once: true });
	initWhenReady();
})();
